import { PermissionStatus } from '@capacitor/geolocation'

const GEOLOCATION_ERROR_CODE = {
  PERMISSION_DENIED: 1,
  POSITION_UNAVAILABLE: 2,
} as const

const PERMISSION_DENIED_SNIPPETS = ['permission request was denied', 'permission denied', 'user denied']
const LOCATION_DISABLED_SNIPPETS = [
  'location services',
  'location unavailable',
  'location disabled',
  'enable location',
  'network and location',
  'gps',
]

export const errorMessageContains = (error: unknown, snippets: readonly string[]): boolean => {
  const message = error instanceof Error ? error.message.toLowerCase() : String(error).toLowerCase()
  return snippets.some((snippet) => message.includes(snippet))
}

export const isLocationDisabledError = (error: unknown): boolean => {
  const hasErrorCode = error && typeof error === 'object' && 'code' in error
  if (hasErrorCode && error.code === GEOLOCATION_ERROR_CODE.POSITION_UNAVAILABLE) return true
  return errorMessageContains(error, LOCATION_DISABLED_SNIPPETS)
}

export const isPermissionDeniedError = (error: unknown): boolean => {
  const hasErrorCode = error && typeof error === 'object' && 'code' in error
  if (hasErrorCode && error.code === GEOLOCATION_ERROR_CODE.PERMISSION_DENIED) return true
  return errorMessageContains(error, PERMISSION_DENIED_SNIPPETS)
}

export const hasLocationAccess = (status: PermissionStatus): boolean =>
  status.location === 'granted' || status.coarseLocation === 'granted'

export const isLocationDenied = (status: PermissionStatus): boolean =>
  status.location === 'denied' && status.coarseLocation === 'denied'

export const canPromptLocation = (status: PermissionStatus): boolean =>
  status.location === 'prompt' || status.coarseLocation === 'prompt'
